import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from 'react-i18next';
import { API_URLS } from '../constants/apiUrl';
import { useLoading } from '../context/LoadingContext';
import { deleteAPI } from '../api/api';
import { showToast } from '../components/utils/toast';

const deleteNoteAttachment = async (notesId: string): Promise<void> => {
  return deleteAPI(`${API_URLS.DELETE_NOTES_ATTACHMENT.replace(':id', notesId)}`);
};

export const useDeleteNoteAttachment = (): UseMutationResult<
  void,
  AxiosError<{ message?: string; type?: string }>,
  string
> => {
  const { setIsLoading } = useLoading();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: deleteNoteAttachment,
    onMutate: () => {
      setIsLoading(true);
    },
    onSuccess: () => {
      showToast('success', t('note:noteAttachmentDeleteSuccess'));
    },
    onError: (error) => {
      showToast('error', error.message);
    },
    onSettled: () => {
      setIsLoading(false);
    },
  });
};
